import { render } from "./UiMessage.vue?vue&type=template&id=730b79fc"
import script from "./UiMessage.vue?vue&type=script&lang=js"
export * from "./UiMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__